import classNames from 'classnames';
import React__default, { useState } from 'react';
import { getVariantAttr } from '../utils.js';

const SwatchPicker = (props) => {
    var _a;
    const { variants, onClick, options } = props, { aemConfig, t = (key, defaultValue) => defaultValue || key, } = options, [viewIndex, setViewIdx] = useState(0);
    if (!(variants === null || variants === void 0 ? void 0 : variants.length) && variants.length < 2) {
        // No other variants
        return React__default.createElement(React__default.Fragment, null);
    }
    const swatchData = variants.map((variant) => {
        const colourName = getVariantAttr(variant, 'WEB_TS_COLOUR', aemConfig.locale);
        const colourNamePath = colourName.toLowerCase().replace(/[^a-zA-Z0-9]/g, '_') + ".jpg";
        const swatchImageUrl = ['/content/dam/breville-brands/global/swatch', colourNamePath].filter(Boolean).join('/');
        return {
            sku: variant.sku,
            colourName,
            swatchImageUrl
        };
    });
    const title = ((_a = swatchData === null || swatchData === void 0 ? void 0 : swatchData[viewIndex]) === null || _a === void 0 ? void 0 : _a.colourName) || "Variant";
    function onSwatchClick(evt) {
        const target = evt.currentTarget;
        const index = parseInt(target.dataset['index'] || '-1');
        if (typeof onClick === 'function' && viewIndex !== index) {
            onClick(index);
        }
        setViewIdx(index);
        return false;
    }
    return (React__default.createElement("div", { className: "dt-swatch-picker", "data-testid": "dt-swatch-picker" },
        React__default.createElement("p", { className: "swatch-title" }, title),
        React__default.createElement("div", { className: "swatch-options" }, swatchData.map((swatch, idx) => {
            const btnClasses = classNames("swatch-btn", {
                "active": idx === viewIndex
            });
            return (React__default.createElement("button", { key: idx, type: "button", className: btnClasses, "data-index": idx, onClick: onSwatchClick },
                React__default.createElement("img", { alt: swatch.sku, src: swatch.swatchImageUrl, width: "35", height: "35", loading: "lazy" })));
        }))));
};

export { SwatchPicker };
//# sourceMappingURL=index.js.map
